module.exports = __webpack_public_path__ + "static/media/checkbox.3b843826.svg";